// React import not required for new JSX transform
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  CircularProgress,
  Card,
  Alert,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import useDashboardsFromServices from './utils/useDashboardsFromServices';
import { useNavigate } from 'react-router-dom';
import { withAccount } from '@/utils/withAccount';

const DashboardPage = () => {
  const { accountId } = useParams();
  const { dashboards, isLoading, isFetching, error } =
    useDashboardsFromServices();
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(withAccount(accountId, path));
  };

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Dashboards
      </Typography>

      {isLoading || isFetching ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">Failed to load account.</Typography>
      ) : dashboards.length > 0 ? (
        <Card>
          <List>
            {dashboards.map((d) => (
              <ListItemButton key={d.id} onClick={() => handleNavigate(d.path)}>
                {d.icon && <ListItemIcon>{d.icon}</ListItemIcon>}
                <ListItemText primary={d.title} secondary={d.description} />
              </ListItemButton>
            ))}
          </List>
        </Card>
      ) : (
        <Alert severity="info">Ingen dashboards at vise.</Alert>
      )}
    </Box>
  );
};

export default DashboardPage;
